import React from "react";
import { Button } from "react-bootstrap";

interface ClearValueBtnProps {
    onClearValue: () => void;
    right?: number;
}

const ClearValueBtn: React.FC<ClearValueBtnProps> = ({ onClearValue, right = 12 }) => {
    return (
        <div className={"position-absolute top-50 translate-middle-y ps-2 bg-white"} style={{ right: `${right}px` }}>
            <Button
                variant="link"
                type="button"
                className={"text-dark text-decoration-none p-0 d-flex"}
                onClick={onClearValue}
            >
                <i className="bi bi-x-lg d-flex"></i>
            </Button>
        </div>
    );
};

export default ClearValueBtn;
